import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Check, AlertCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const session_id = sp.get("session_id");
  const order_id = sp.get("order_id");
  const [status, setStatus] = useState("checking");
  const navigate = useNavigate();

  useEffect(() => {
    if (!session_id) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/checkout/status/${session_id}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        attempts++;
        if (attempts < 6) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [session_id]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-sm w-full bg-white rounded-2xl border border-neutral-200 p-8 text-center">
        {status === "paid" && (
          <>
            <div className="h-16 w-16 mx-auto rounded-full bg-green-100 text-green-700 flex items-center justify-center"><Check size={32} /></div>
            <h1 className="mt-4 font-display font-extrabold text-2xl">¡Pago exitoso!</h1>
            <p className="text-neutral-500 text-sm mt-2">Estamos preparando tu pedido.</p>
            <button onClick={() => navigate(`/app/orders/${order_id}`)} className="mt-6 w-full h-11 rounded-xl bg-company text-[color:var(--company-primary-contrast)] font-semibold" data-testid="go-order-btn">Ver pedido</button>
          </>
        )}
        {status === "checking" && <p className="text-neutral-500">Verificando pago...</p>}
        {(status === "error" || status === "expired" || status === "pending") && (
          <>
            <div className="h-16 w-16 mx-auto rounded-full bg-amber-100 text-amber-700 flex items-center justify-center"><AlertCircle size={32} /></div>
            <h1 className="mt-4 font-display font-extrabold text-2xl">Verificación pendiente</h1>
            <p className="text-neutral-500 text-sm mt-2">El pago está siendo procesado. Revisa tus pedidos en unos minutos.</p>
            <button onClick={() => navigate("/app/orders")} className="mt-6 w-full h-11 rounded-xl bg-company text-[color:var(--company-primary-contrast)] font-semibold">Mis pedidos</button>
          </>
        )}
      </div>
    </div>
  );
}
